import { Component, inject } from '@angular/core';
import { SubscriptionCancelReasons } from '../../../../../_interfaces/subscription.interface';
import { NgClass } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../../../../../shared/components/modals/modal/modal.component';
import { SubscriptionApiService } from '../../../../../_services/subscription-service/api/subscription-api-service.service';

@Component({
  selector: 'app-cancel-subscription-modal',
  templateUrl: './cancel-subscription-modal.html',
  imports: [NgClass],
})
export class CancelSubscriptionModalComponent extends ModalComponent {
  readonly subscriptionApiService = inject(SubscriptionApiService);
  override readonly ngbActiveModal: NgbActiveModal;

  protected subscriptionReasons?: SubscriptionCancelReasons[];
  protected selectedReason?: number;

  constructor() {
    const ngbActiveModal = inject(NgbActiveModal);

    super();
    this.ngbActiveModal = ngbActiveModal;

    this.getCancelSubscriptionReasons();
  }

  onReasonSelect(id: number) {
    this.selectedReason = id;
  }

  getCancelSubscriptionReasons() {
    this.subscriptionApiService.getSubscriptionCancelReasons().subscribe({
      next: (res) => {
        this.subscriptionReasons = res;
      },
    });
  }
}
